import React, { useState } from 'react';
import AdminLayout from './AdminLayout';

const AdminLayoutWrapper = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true); // Collapsed by default; user clicks arrow to expand
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AdminLayout
      open={mobileOpen}
      onClose={handleDrawerToggle}
      collapsed={collapsed}
      onToggleCollapse={handleToggleCollapse}
    >
      {children}
    </AdminLayout>
  );
};

export default AdminLayoutWrapper;
